import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const HelpAssistantContainer = styled.div`
  position: fixed;
  display: flex;
  gap: 20px;
  align-items: flex-start;
  z-index: 1000;
  pointer-events: none; /* Allow clicking through the container */
`;

const Assistant = styled.div`
  width: 80px;
  height: 80px;
  background: url('/images/helper.svg') no-repeat center;
  background-size: contain;
  animation: bounce 2s infinite;
  cursor: grab;
  pointer-events: auto; /* Re-enable pointer events for the assistant */

  &:active {
    cursor: grabbing;
  }

  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }
`;

const DialogBox = styled.div`
  flex: 1;
  background: #ffffff;
  border: 2px solid;
  border-color: #808080 #ffffff #ffffff #808080;
  padding: 15px;
  position: relative;
  font-size: 14px;
  line-height: 1.4;
  font-family: 'MS Sans Serif', monospace;
  min-width: 200px;
  max-width: 300px;
  pointer-events: auto; /* Re-enable pointer events for the dialog */

  &:before {
    content: '';
    position: absolute;
    left: -10px;
    top: 20px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #ffffff;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: -12px;
  right: -12px;
  width: 24px;
  height: 24px;
  background: #c0c0c0;
  border: 2px solid;
  border-color: #ffffff #808080 #808080 #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'MS Sans Serif', monospace;
  font-size: 12px;
  cursor: pointer;
  pointer-events: auto;

  &:active {
    border-color: #808080 #ffffff #ffffff #808080;
  }
`;

const helpMessages = [
    "how hard is it to just click things?",
  "you really need help? this is a bad operating system clone. ngmi.",
  "honestly just alt+f4 at this point... ngmi.",
  "ok actual tip, type snake in the notepad and press enter. based.",
  "this job sucks",
  "i'm not even gonna help you",
  "i'm gonna cycle through these messsages to act like i'm helping you",
];

export const Help = ({ onClose }) => {
  const [currentMessage, setCurrentMessage] = useState(0);
  const [position, setPosition] = useState({ 
    x: Math.max(window.innerWidth * 0.25, 100), // 25% from the left edge
    y: window.innerHeight - 200 // Still above taskbar
  });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentMessage((prev) => (prev + 1) % helpMessages.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setDragOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y
    });
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isDragging) {
        setPosition({
          x: Math.min(Math.max(0, e.clientX - dragOffset.x), window.innerWidth - 400),
          y: Math.min(Math.max(0, e.clientY - dragOffset.y), window.innerHeight - 100)
        });
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, dragOffset]);

  return (
    <HelpAssistantContainer
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`
      }}
    >
      <Assistant onMouseDown={handleMouseDown} />
      <DialogBox>
        {helpMessages[currentMessage]}
        <CloseButton onClick={onClose}>×</CloseButton>
      </DialogBox>
    </HelpAssistantContainer>
  );
}; 